// extracted by mini-css-extract-plugin
module.exports = {"stats":"Stats_stats__aLBnT"};